'use strict';
// 1. Отримуємо всі елементи з класом "population"
var populationElements = document.querySelectorAll('.population');
// 2. Парсимо текст → число
var populations = Array.from(populationElements).map(function(el) {
    return el.textContent.replace(/,/g, '');
}) // прибираємо коми
.map(function(num) {
    return Number(num);
}) // конвертуємо в число
.filter(function(num) {
    return !Number.isNaN(num);
}); // відкидаємо нечислові значення
// 3. Рахуємо total та average
var total = populations.reduce(function(sum, n) {
    return sum + n;
}, 0);
var average = total / populations.length;
// 4. Форматуємо з thousands separator
var format = function(num) {
    return num.toLocaleString('en-US');
};
// 5. Вставляємо значення в DOM
document.querySelector('.total-population').textContent = format(total);
document.querySelector('.average-population').textContent = format(Math.round(average));

//# sourceMappingURL=js_get_data_DOM.73117397.js.map
